/**
 * Rule-based recovery advisor: maps free-text issues to homepage product ids.
 * Not a medical device; suggestions are wellness / convenience only.
 */
const RULES = [
  {
    id: 'kneerevive',
    keywords: ['knee', 'patella', 'meniscus', 'squat', 'runner knee', 'it band', 'marathon', 'cycling knee'],
    reason: 'Heat plus vibration focused on the knee joint—ideal after runs, leg day, or long stairs.',
  },
  {
    id: 'shoulderease-flex',
    keywords: ['shoulder max', 'heavy shoulder', 'stronger shoulder', 'flex pro', 'both shoulders chronic'],
    reason: 'Stronger shoulder wrap programmes and magnetic fit when you need daily, high-use recovery.',
  },
  {
    id: 'shoulderease',
    keywords: ['shoulder', 'rotator', 'desk', 'typing', 'upper back', 'trap', 'lifting shoulder'],
    reason: 'Heat and vibration protocols for shoulder and upper-back tightness from training or desk posture.',
  },
  {
    id: 'protherm',
    keywords: ['massage gun', 'percussion', 'deep tissue', 'quad', 'hamstring', 'glute', 'tight calves', 'foam roll'],
    reason: 'Hot-and-cold percussion for large muscle groups and deep soreness between sessions.',
  },
  {
    id: 'pulsepad',
    keywords: ['tens', 'ems', 'nerve', 'activation', 'electrode', 'stim', 'muscle wake', 'prehab'],
    reason: 'Wireless TENS + EMS for muscle activation and relief you can program from your pocket.',
  },
  {
    id: 'fasciablade',
    keywords: ['fascia', 'scrape', 'knot', 'tool', 'scar tissue', 'warm up tool', 'microcurrent'],
    reason: '3-in-1 heated fascia work—microcurrent, heat, and vibration for stubborn spots.',
  },
  {
    id: 'thermacube',
    keywords: [
      'ice',
      'cold',
      'heat',
      'contrast',
      'swelling',
      'sprain',
      'post game',
      'recovery day',
      'travel',
      'one device',
      'replace ice pack',
    ],
    reason: 'Pocket contrast therapy—automated heat/cold cycles without juggling packs and timers.',
  },
];

const DEFAULT_ID = 'thermacube';

export function suggestRecoveryProduct(message, lineupById) {
  const text = String(message || '').toLowerCase();
  if (!text.trim()) {
    const p = lineupById[DEFAULT_ID];
    return {
      productId: DEFAULT_ID,
      product: p,
      reason: 'Tell me where it hurts or what you did in training (e.g. “sore knees after a half marathon”).',
    };
  }

  for (const rule of RULES) {
    if (rule.keywords.some((k) => text.includes(k.toLowerCase()))) {
      const p = lineupById[rule.id];
      return { productId: rule.id, product: p, reason: rule.reason };
    }
  }

  const p = lineupById[DEFAULT_ID];
  return {
    productId: DEFAULT_ID,
    product: p,
    reason:
      'For all-around athlete recovery, contrast therapy is the most versatile starting point—then add a targeted tool if you need joint or percussion focus.',
  };
}
